import React, { useState, useEffect } from 'react'
import bgImg from '../../../assets/images/download.jpg'
import EPLogo from '../../../assets/images/EPLOGO.png'
import { BsFillSignTurnSlightLeftFill } from "react-icons/bs";

import { useSelector } from 'react-redux';
import { selectUserData } from '../../../reducers/user.reducer';

import { createTransferService } from '../../../services/transfer.service';
import { useDispatch } from 'react-redux';
import { setToastMessage } from "../../../reducers/common.reducer";

import TransferTypeSB from './TransferTypeSB'
import useTransferTypeData from '../../../hooks/useTransactionTypeData';
import { v4 as uuidv4 } from "uuid";
import { FaSpinner } from 'react-icons/fa';
const TransactionModal = (props) => {

    const { isOpen, setIsOpen, transaction } = props;
    const [isLoading, setIsLoading] = useState(false)
    const [transferTypeData, setTransferTypeData] = useTransferTypeData([]);
    const [expand, setExpand] = useState(false);
    const [input, setInput] = useState(0);
    const [ans, setAns] = useState(0);

    const [transferType, setTransferType] = useState({'transactionTypeId': '', 'transactionType' : 'Transfer Type'});
    const [toUser, setToUser] = useState({ 'userId': '', 'name': '' });
    const [errors, setErrors] = useState({});
    const [isDelay, setIsDelay] = useState(false);

    const dispatch = useDispatch();
    const userData = useSelector(selectUserData);

    useEffect(() => {
        setToUser({
            'userId': userData?.userInfo?.userId,
            'name': userData?.userInfo?.name
        });
    }, [userData]);

    const handleWheel = (event) => event.target.blur();

    const selectTransferType=(e)=>{
        e.stopPropagation();
        setExpand(!expand);
    }

    const handleChange = (e) => {
        // setInput(e.target.value);
        const newInput = parseFloat(e.target.value);
        const newRemain = parseFloat(transaction.remain);

        setInput(newInput);
        if(newInput > 0) {
            setAns(newRemain + newInput);
        }else if(newInput < 0) {
            setAns(newRemain - newInput);
        }

    }

    const handleCloseModal = () => {
        setIsOpen(false)
        formReset();
    }

    const formReset = () => {
        setInput(0);
        setAns(0);
    }

    let handleSubmit = async (event) => {
     try { 
        event.preventDefault();
        setIsLoading(true)
        const validateErrors = validate();
        
        if(Object.keys(validateErrors).length > 0) {
             setErrors(validateErrors)
             if (validateErrors.transactionTypeId) {
                dispatch(
                    setToastMessage({
                        message: validateErrors.transactionTypeId,
                        type: "error",
                    })
                );
            }
            return 
        } else {
            setErrors({})
        }
        

        if(toUser.userId === '')
            setToUser({
                'userId': userData?.userInfo?.userId,
                'name': userData?.userInfo?.name
            });

            let type = '';
            if(transaction.remain > 0) {
                type = 'outward';
            }
            if(transaction.remain < 0) {
                type = 'inward';
            }

           const requestId =  uuidv4();
           const result = await createTransferService({
                requestId,
                fromAgentId: transaction.agentId,
                toUserId: toUser.userId,
                transactionTypeId: transferType.transactionTypeId,
                amount: input,
                type: type
            })

            if(result) {
                dispatch(
                    setToastMessage({
                    message: result.data.message,
                    type: "success",
                    })
                );
                window.location.reload();
                // setTimeout(() => {
                // }, 2000)
            }
            } catch (error) {
                const errorMessage =
                    error?.response?.data?.error?.includes('streaming buffer')
                        ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                        : error?.response?.data?.message || error?.message;

                dispatch(
                    setToastMessage({
                        message: errorMessage,
                        type: "error",
                    })
                );
            } finally {
            setIsLoading(false)
        }
       
    }

    const validate = () => {
        let errors = {};
        if(!input) {
            errors.amount = 'Amount is required';
        }
        else if(transferType.transactionTypeId === '') {
            errors.transactionTypeId = 'Transfer Type is required';
        }

        return errors;
    }

    // const createAction = async () => {
    //     dispatch(setIsLoading(true))

    //     if(toUser.userId === '')
    //         setToUser({
    //             'userId': userData?.userInfo?.userId,
    //             'name': userData?.userInfo?.name
    //         });

    //         let type = '';
    //         if(transaction.remain > 0) {
    //             type = 'outward';
    //         }
    //         if(transaction.remain < 0) {
    //             type = 'inward';
    //         }

    //     try {
    //         let result;
    //         result = await createTransferService({
    //             fromAgentId: transaction.agentId,
    //             toUserId: toUser.userId,
    //             transactionTypeId: transferType.transactionTypeId,
    //             amount: input,
    //             type: type
    //         })

    //         if(result) {
    //             dispatch(
    //                 setToastMessage({
    //                 message: result.data.message,
    //                 type: "success",
    //                 })
    //             );
    //             window.location.reload();
    //             // setTimeout(() => {
    //             // }, 2000)
    //         }
    //         } catch (error) {
    //             const errorMessage =
    //                 error?.response?.data?.error?.includes('streaming buffer')
    //                     ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
    //                     : error?.response?.data?.message || error?.message;

    //             dispatch(
    //                 setToastMessage({
    //                     message: errorMessage,
    //                     type: "error",
    //                 })
    //             );
    //         } finally {
    //         dispatch(setIsLoading(false))
    //     }
    // }


    return (
        <>
            {isOpen && (
                <div className='fixed inset-0 z-50 flex items-center justify-center bg-white'>
                    <img className="h-full w-full relative blur-lg" src={bgImg} alt="" />

                        <form
                            className='flex flex-col h-[650px] w-[300px] shadow-lg border-2 border-slate-200 bg-white/50 rounded-md absolute'
                            onSubmit={handleSubmit}
                        >

                            <div className='flex flex-col justify-center items-center text-left w-[full] h-[55%] text-lg'>
                                <div className='w-56 mt-32'>
                                    <img className="h-12 mb-12 -ml-3" src={EPLogo} alt="" />

                                    { transaction.remain < 0 ?
                                        <div className=''>
                                            <div className='w-full font-bold text-xl'>{transaction.agentName}</div>
                                            <div> » </div>
                                            <div className='w-full mb-8 font-bold text-xl'>{toUser.name}</div>
                                        </div>
                                        :
                                        <div className=''>
                                            <div className='w-full font-bold text-xl'>{toUser.name}</div>
                                            <div> » </div>
                                            <div className='w-full mb-8 font-bold text-xl'>{transaction.agentName}</div>
                                        </div>
                                    }

                                    <input
                                        type="number"
                                        value={input}
                                        onWheel={handleWheel}
                                        onChange={handleChange}
                                        readOnly
                                        className='border-2 border-gray-500 rounded p-2 text-right w-full mb-3 outline-none bg-transparent select-none'
                                    />
                                    { errors.amount && <div className='text-red'>{errors.amount}</div> }

                                    <TransferTypeSB
                                        transferType={transferType}
                                        setTransferType={setTransferType}
                                        selectTransferType={selectTransferType}
                                        transferTypeData={transferTypeData}
                                        setExpandTransferType={setExpand}
                                        expandTransferType={expand}
                                        shadow={false}

                                    />
                                    {   errors.transactionTypeId && <div className='text-red'>{errors.transactionTypeId} </div>
                                    }

                                    <div className='flex gap-1 items-center justify-end mt-5 mr-2'>
                                        <div className='p-2 text-black text-right'>
                                            {transaction.remain}
                                        </div>
                                        <BsFillSignTurnSlightLeftFill
                                            size={28}
                                            className='text-gray-700'
                                            onClick={() => {
                                                setInput(Math.abs(Math.round(transaction.remain)));
                                            }}

                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='w-full flex justify-end mt-32'>
                                <div className='flex flex-col justify-center items-center gap-3'>
                                    <button type='submit' 
                                        className='flex justify-center px-10 py-2 w-36 mr-10 rounded border-2 border-gray-800'
                                        disabled={isLoading}
                                        >
                                        {isLoading ? <FaSpinner className="animate-spin text-2xl text-green-500" /> :"Submit"}
                                    </button>
                                    <button type='button' className='flex justify-center px-10 py-2 w-36 mr-10 rounded border-2 border-gray-800' onClick={handleCloseModal}>Close</button>
                                </div>
                            </div>


                        </form>
                </div>
            )}
        </>
    )
}

export default TransactionModal
